(function () {
  "use strict";

  if (window.__CARD_PRODUCT_SWIPE__) return;
  window.__CARD_PRODUCT_SWIPE__ = true;

  var SWIPE_THRESHOLD = 40;
  var GRIDY_SWIPE_THRESHOLD = 100;
  var bound = new WeakSet();
  var zoomBound = new WeakSet();
  var allowSwipeEverywhere = true;
  var zoomEnabled = window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var ZOOM_FOLLOW_LERP = 0.2;

  var hasTouch = ("ontouchstart" in window) ||
    (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) ||
    (navigator && navigator.maxTouchPoints && navigator.maxTouchPoints > 0);

  function dataBool(value, fallback) {
    if (value === undefined) return fallback;
    if (value === "true") return true;
    if (value === "false") return false;
    return fallback;
  }

  function isHomepage() {
    if (typeof location === "undefined") return false;
    var path = location.pathname || "";
    return path === "/" || path === "/fi" || path === "/fi/";
  }

  function isSliderEnabled(slider) {
    if (!slider) return false;
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    var mobileEnabled = dataBool(slider.dataset.mobileEnabled, true);
    var tabletEnabled = dataBool(slider.dataset.tabletEnabled, true);
    var desktopEnabled = dataBool(slider.dataset.desktopEnabled, true);

    if (width >= 1024) return desktopEnabled;
    if (width >= 768) return tabletEnabled;
    return mobileEnabled;
  }

  function getEnabledSlider(card) {
    if (!card || !card.closest) return null;
    var slider = card.closest("gridy-slider");
    if (!slider || !isSliderEnabled(slider)) return null;
    return slider;
  }

  function hideIndicators(card) {
    if (!card) return;
    var wrap = card.querySelector(".card-image-indicators");
    if (wrap && wrap.style.display !== "none") {
      wrap.style.display = "none";
    }
  }

  function setIndicatorState(indicators, showSecondary) {
    if (!indicators || indicators.length < 2) return;
    if (showSecondary) {
      indicators[0].classList.remove("is-active");
      indicators[1].classList.add("is-active");
    } else {
      indicators[0].classList.add("is-active");
      indicators[1].classList.remove("is-active");
    }
  }

  function clamp(val, min, max) {
    return val < min ? min : (val > max ? max : val);
  }

  function parseDurationMs(value) {
    var str = (value || "").toString().split(",")[0].trim();
    if (!str) return 0;
    var num = parseFloat(str);
    if (!isFinite(num)) return 0;
    if (str.slice(-2) === "ms") return num;
    if (str.slice(-1) === "s") return num * 1000;
    return num * 1000;
  }

  function getZoomDuration(card) {
    var el = card.querySelector(".media > *");
    if (!el || !window.getComputedStyle) return 400;
    var style = getComputedStyle(el);
    var dur = parseDurationMs(style.transitionDuration);
    var delay = parseDurationMs(style.transitionDelay);
    var total = dur + delay;
    return total > 0 ? total : 400;
  }

  function bindZoom(card) {
    if (!zoomEnabled || !card || zoomBound.has(card)) return;
    zoomBound.add(card);

    var media = card.querySelector(".card-media");
    if (!media) return;

    var target = card.querySelector(".card-hover-images .media") ||
      card.querySelector(".card-media .media") ||
      media;
    var zoomOutDelay = getZoomDuration(card);
    var leaveTimer = null;
    var zoomResetTimer = null;
    var zoomRafId = null;
    var zoomCurrentX = null;
    var zoomCurrentY = null;
    var zoomTargetX = null;
    var zoomTargetY = null;

    function setHoverOn() {
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
      if (card.classList.contains("on-hover")) {
        card.classList.add("is-hovered");
      }
    }

    function setHoverOff() {
      if (!card.classList.contains("on-hover")) return;
      if (leaveTimer) clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () {
        card.classList.remove("is-hovered");
        leaveTimer = null;
      }, zoomOutDelay);
    }

    function clearZoomReset() {
      if (!zoomResetTimer) return;
      clearTimeout(zoomResetTimer);
      zoomResetTimer = null;
    }

    function scheduleZoomReset() {
      clearZoomReset();
      zoomResetTimer = setTimeout(function () {
        card.style.removeProperty("--card-zoom-x");
        card.style.removeProperty("--card-zoom-y");
        zoomResetTimer = null;
      }, zoomOutDelay);
    }

    function setZoomOn() {
      clearZoomReset();
      card.classList.add("is-zoomed");
    }

    function setZoomOff() {
      if (zoomRafId) {
        cancelAnimationFrame(zoomRafId);
        zoomRafId = null;
      }
      card.classList.remove("is-zoomed");
      scheduleZoomReset();
    }

    function setZoomPoint(x, y) {
      card.style.setProperty("--card-zoom-x", clamp(x, 0, 100) + "%");
      card.style.setProperty("--card-zoom-y", clamp(y, 0, 100) + "%");
    }

    function stepZoomFollow() {
      if (zoomTargetX === null || zoomTargetY === null) {
        zoomRafId = null;
        return;
      }

      if (zoomCurrentX === null || zoomCurrentY === null) {
        zoomCurrentX = zoomTargetX;
        zoomCurrentY = zoomTargetY;
      } else {
        zoomCurrentX += (zoomTargetX - zoomCurrentX) * ZOOM_FOLLOW_LERP;
        zoomCurrentY += (zoomTargetY - zoomCurrentY) * ZOOM_FOLLOW_LERP;
      }

      var dx = Math.abs(zoomTargetX - zoomCurrentX);
      var dy = Math.abs(zoomTargetY - zoomCurrentY);
      if (dx < 0.05 && dy < 0.05) {
        zoomCurrentX = zoomTargetX;
        zoomCurrentY = zoomTargetY;
      }

      setZoomPoint(zoomCurrentX, zoomCurrentY);

      if (zoomCurrentX === zoomTargetX && zoomCurrentY === zoomTargetY) {
        zoomRafId = null;
        return;
      }

      zoomRafId = requestAnimationFrame(stepZoomFollow);
    }

    function update(e, immediate) {
      var rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      zoomTargetX = clamp(x, 0, 100);
      zoomTargetY = clamp(y, 0, 100);

      if (immediate || zoomCurrentX === null || zoomCurrentY === null) {
        zoomCurrentX = zoomTargetX;
        zoomCurrentY = zoomTargetY;
        setZoomPoint(zoomCurrentX, zoomCurrentY);
        return;
      }

      if (!zoomRafId) {
        zoomRafId = requestAnimationFrame(stepZoomFollow);
      }
    }

    media.addEventListener("mouseenter", function (e) {
      setZoomOn();
      update(e, true);
    });
    media.addEventListener("mousemove", function (e) {
      update(e, false);
    });
    media.addEventListener("mouseleave", setZoomOff);
    card.addEventListener("mouseenter", setHoverOn);
    card.addEventListener("mouseleave", setHoverOff);
  }

  function scrollSlider(slider, direction) {
    if (!slider) return;
    if (typeof slider.scrollTrackBy === "function") {
      slider.scrollTrackBy(direction);
      return;
    }
    if (typeof slider.scrollByIPR === "function") {
      slider.scrollByIPR(direction);
      return;
    }

    var track = slider.track || slider.querySelector(".gridy-track");
    if (!track) return;
    var delta = track.clientWidth || 0;
    if (!delta) return;
    var offset = direction === "prev" ? -delta : delta;
    if (track.scrollBy) {
      track.scrollBy({ left: offset, top: 0, behavior: "smooth" });
    } else {
      track.scrollLeft += offset;
    }
  }

  function bindSwipe(el) {
    if (!el || bound.has(el)) return;

    var card = el.closest(".card.card--product.on-hover");
    if (!card) {
      bound.add(el);
      return;
    }

    if (!allowSwipeEverywhere && (isHomepage() || getEnabledSlider(card))) {
      hideIndicators(card);
      bound.add(el);
      return;
    }

    bound.add(el);
    if (!hasTouch) return;

    var indicators = card.querySelectorAll(".card-image-indicator");
    var startX = 0;
    var startY = 0;
    var isSwiping = false;
    var suppressClick = false;
    var activeSlider = null;

    el.addEventListener("touchstart", function (e) {
      if (!e.touches || !e.touches.length) return;
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      isSwiping = false;
      suppressClick = false;
      activeSlider = getEnabledSlider(card);
    }, { passive: true });

    el.addEventListener("touchmove", function (e) {
      if (!e.touches || !e.touches.length) return;
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      var absX = Math.abs(dx);
      var absY = Math.abs(dy);

      if (absX < SWIPE_THRESHOLD || absX < absY) return;

      isSwiping = true;
      suppressClick = true;
      e.preventDefault();
    }, { passive: false });

    el.addEventListener("touchend", function (e) {
      if (!isSwiping || !e.changedTouches || !e.changedTouches.length) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var absX = Math.abs(dx);

      if (activeSlider && absX >= GRIDY_SWIPE_THRESHOLD) {
        scrollSlider(activeSlider, dx < 0 ? "next" : "prev");
        return;
      }

      if (absX < SWIPE_THRESHOLD) return;

      if (dx < 0) {
        card.classList.add("is-secondary");
        setIndicatorState(indicators, true);
      } else {
        card.classList.remove("is-secondary");
        setIndicatorState(indicators, false);
      }
    });

    el.addEventListener("click", function (e) {
      if (!suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }, true);
  }

  function scanCards() {
    var cards = document.querySelectorAll(".card.card--product.on-hover");
    var onHome = isHomepage();

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (!allowSwipeEverywhere && (onHome || getEnabledSlider(card))) {
        hideIndicators(card);
      }
    }

    if (hasTouch) {
      var nodes = document.querySelectorAll(".card.card--product.on-hover .card-media");
      for (var j = 0; j < nodes.length; j++) {
        bindSwipe(nodes[j]);
      }
    }

    if (zoomEnabled) {
      var zoomCards = document.querySelectorAll(".card.card--product");
      for (var k = 0; k < zoomCards.length; k++) {
        bindZoom(zoomCards[k]);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanCards);
  } else {
    scanCards();
  }

  ["ajaxinate:loaded", "shopify:section:load", "collection:updated", "product-grid:updated"]
    .forEach(function (evt) {
      document.addEventListener(evt, scanCards);
    });

  var moAdd = new MutationObserver(function (muts) {
    var doit = false;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        doit = true;
        break;
      }
    }
    if (doit) {
      requestAnimationFrame(scanCards);
    }
  });
  moAdd.observe(document.documentElement, { childList: true, subtree: true });
})();
